import axios from "axios";

import { currentEnv } from "./environments";

const APP_ID = import.meta.env.VITE_APP_ID;
const APP_SECRET = import.meta.env.VITE_APP_SECRET;

const client = axios.create({ baseURL: currentEnv.baseUrl });

client.interceptors.request.use((config) => {
  if (!config) return config;
  const lang = localStorage?.getItem("i18nextLng")?.toString()?.toLowerCase() === "en" ? 1 : 0;
  config.params = {
    ...(config.params || {}),
    app_id: APP_ID,
    app_secret: APP_SECRET,
    lang: lang,
  };
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (response && response.status === 200) {
      const data = response.data as any;
      if (data && typeof data.responseCode !== "undefined" && data.responseCode !== 0) {
        const err: any = new Error(data.responseDesc || "Server error");
        err.response = response;
        err.code = String(data.responseCode);
        return Promise.reject(err);
      }
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export default client;
